module.exports = __webpack_public_path__ + "img/imageAdd2.c9ffb40b.jpg";